import {TextEncoder} from "encoding";
import moment from 	"moment";
import sleep from "sleep";
import Bottleneck from "bottleneck";



class Module {
  constructor(serialPort) {    

    this.id = "otr";
    this.status = "uninitialized";    
    this.name = "otr";
    this.serialPort = serialPort;
    
    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });        

    jfermi.RM_otr_setChannel = this.setChannel.bind(this);
  }
  async initialize() {
    try {            
      await this.serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });          
      
      await sleep(200);
      await this.setChannel('N', 0);      
      await sleep(200);
      await this.setChannel('A', 0);
      
      this.usbProductName = (await this.serialPort.getInfo()).usbProductName;
	  this.usbSerialNumber = (await this.serialPort.getInfo()).usbSerialNumber;    
      
      this.status = "OK";                          
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {              
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  }
  /* 
    fermentation: details of the currently running fermentation paramters
    devices: parameters of each connected devices
  */
  async control(fermentation, devices) {
  }
  async setChannel(n, value) {   
    return await this.limiter.schedule(() => this.__setChannel(n, value));    
  }
  async __setChannel(n, value) {
    await sleep(200);
    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${value}${n}`).buffer);
    writer.releaseLock();        
  }
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status
    });
  }
}

export default Module;